import { NgClass, NgForOf, NgIf, TitleCasePipe } from '@angular/common';
import { Component, EventEmitter, OnDestroy, OnInit, Output, ViewContainerRef } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatOption } from '@angular/material/core';
import { MatSelect } from '@angular/material/select';
import { MatTooltip } from '@angular/material/tooltip';
import {Router} from '@angular/router';
import { Subscription } from 'rxjs';
import { LoadingComponent } from '../../../loading/loading.component';
import {DataToolsApps, DataToolsAppsTitles} from '../../../shared/DataToolsApps';
import { MessageNotificationService } from '../../../shared/services/message-notification.service';
import {ReportFieldOptionsService} from './report-field-options.service';
import { SelectedFields } from './selected-fields.model';

@Component({
  selector: 'app-report-field-options',
  templateUrl: './report-field-options.component.html',
  imports: [
    NgClass,
    MatTooltip,
    NgIf,
    LoadingComponent,
    NgForOf,
    TitleCasePipe,
    MatSelect,
    MatOption,
    FormsModule
  ],
  styleUrls: ['./report-field-options.component.scss']
})
export class ReportFieldOptionsComponent implements OnInit, OnDestroy {

  @Output()
  needsSavingEmitter: EventEmitter<boolean> = new EventEmitter<boolean>();

  entities = ['candidate', 'contact', 'company'];
  loading = {
    candidate: false,
    contact: false,
    company: false
  };
  loadTriggered = false;

  needSaving = false;
  saving = false;
  BHMetaFields = {
    candidate: [],
    contact: [],
    company: [],
  };
  selectedFields = new SelectedFields();

  duplikitDashboardLink = DataToolsApps.DUPLIKIT_DASHBOARD;
  DataToolsApps = DataToolsApps;
  DataToolsAppsTitles = DataToolsAppsTitles;
  private selectedReportFieldsSubscription: Subscription;

  constructor(
    public router: Router,
    private reportFieldOptionsService: ReportFieldOptionsService,
    private view: ViewContainerRef,
    private messageNotificationService: MessageNotificationService
  ) {
  }

  ngOnInit() {
  }

  expandAndLoad() {
    this.loadTriggered = true;
    this.loading = {
      candidate: true,
      contact: true,
      company: true
    };

    this.entities.forEach((entity: string) => {
      this.getAvailableBHFields(entity);
      this.getSelectedReportFields(entity);
    });
  }

  change(): void {
    this.needSaving = true;
    this.needsSavingEmitter.emit(this.needSaving);
    // TODO: remove already selected values from list.
  }

  private getSelectedReportFields(entity: string): void {
    this.selectedReportFieldsSubscription = this.reportFieldOptionsService.getSelectedReportFields(entity)
        .subscribe((dataReceived: any[]) => {
          this.selectedFields[entity] = dataReceived ? [...dataReceived] : [];
        });
  }

  getAvailableBHFields(entity: string): void {
    this.reportFieldOptionsService.getAvailableBHFields(entity).subscribe((dataReceived) => {
      // TODO: discard ones already showing
      this.BHMetaFields[entity] = dataReceived.sort((a, b) => {
        const labelA = a.fieldLabel ?? a.fieldName;
        const labelB = b.fieldLabel ?? b.fieldName;
        return labelA.localeCompare(labelB);
      });
      this.loading[entity] = false;
    }, (error) => {
      console.error(error);
      this.loading[entity] = true;
      this.messageNotificationService.error(
          'There was an error trying to get the list of Bullhorn fields. Please try reloading the page.',
          error
      );
    });
  }

  removeSelectedField(entity: string, index: number): void {
    this.selectedFields[entity].splice(index, 1);
    this.change();
  }

  addReportField(entity: string): void {
    this.selectedFields[entity].push(this.BHMetaFields[entity][0].fieldName);
    this.change();
  }

  ngOnDestroy() {
    this.selectedReportFieldsSubscription?.unsubscribe();
  }

}
